class QuizFilter extends HTMLElement {
  constructor() {
    super();
    this.initialize = this.initialize.bind(this);
    this.handleQuizCloseClick = this.handleQuizCloseClick.bind(this);

    document
      .querySelector('.button--back-to-quiz')
      ?.addEventListener('click', () => {
        this.isHidden = false;
        const questions_total = this.querySelector('.quiz-question_total')?.dataset
          .value;
        const values = this.querySelectorAll('.quiz-go-back-hidden');

        if (parseInt(questions_total) === values.length) {
          const paramToRemove = values[values.length - 1]?.dataset.value;
          const query = new URLSearchParams(window.location.search);
          query.delete(paramToRemove);

          FacetFiltersForm.renderPage(query.toString());
        } else {
          this.initialize();
        }
      });

    this.initialize();
  }

  initialize() {
    this.classList.remove('loading');

    const cards = this.querySelectorAll('.card-quiz');
    if (cards.length === 0 || this.isHidden) {
      this.classList.add('hide');
      document.body.classList.remove('no-scroll');

      this.querySelector('.quiz-back')?.removeEventListener(
        'click',
        this.handleQuizBackClick
      );
      this.querySelector('.close-quiz')?.removeEventListener(
        'click',
        this.handleQuizCloseClick
      );

      for (let i = 0; i < cards.length; i++) {
        const el = cards[i];
        el.removeEventListener('click', this.handleQuizCardClick);
      }

      return;
    }
    this.classList.remove('hide');

    this.querySelector('.quiz-back')?.addEventListener(
      'click',
      this.handleQuizBackClick
    );
    this.querySelector('.close-quiz')?.addEventListener(
      'click',
      this.handleQuizCloseClick
    );

    document.body.classList.add('no-scroll');
    for (let i = 0; i < cards.length; i++) {
      const el = cards[i];
      el.addEventListener('click', this.handleQuizCardClick);
    }
  }

  handleQuizCardClick() {
    const input = this.querySelector('input');
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(input.name, input.value);

    FacetFiltersForm.renderPage(searchParams.toString());
  }

  handleQuizBackClick() {
    if (!this.dataset.removeValue) return;
    const query = new URLSearchParams(window.location.search);
    query.delete(this.dataset.removeValue);

    FacetFiltersForm.renderPage(query.toString());
  }

  handleQuizCloseClick() {
    this.isHidden = true;
    this.initialize();
  }

  createSearchParams(key, value) {
    const query = new URLSearchParams(window.location.search);
    query.set(key, value);
    return query.toString();
  }

  static test() {
    console.log(this);
  }
}

QuizFilter.searchParamsInitial = window.location.search.slice(1);
QuizFilter.searchParamsPrev = window.location.search.slice(1);

customElements.define('quiz-filter', QuizFilter);
